/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TextField type=search, NS/Tractie search-input-pendant overrides.
// Tractie source: search-input.
// Tractie search-input erft input-base; verschil is padding-inline-start (43px ruimte
// voor 24x24 search-icon) en search-icon-color subtle. Icon zelf wordt door consument
// (Backstage SearchBar of NS-component) geleverd; deze override garandeert de
// padding-claim zodat icon ruimte heeft.
// Mode-split: Dark spread Light.

export const MuiTextFieldSearchLightOverrides = {
  root: {
    '& input[type="search"]': {
      paddingInlineStart:
        'calc(var(--ns-control-padding-x-m) + var(--ns-control-icon-size-l) + var(--ns-space-2))',
      '&::-webkit-search-decoration': {
        WebkitAppearance: 'none' as const,
      },
      '&::-webkit-search-cancel-button': {
        WebkitAppearance: 'none' as const,
      },
    },
  },
} as const;

export const MuiTextFieldSearchDarkOverrides = {
  ...MuiTextFieldSearchLightOverrides,
} as const;
